// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"58a50cf752e1aa4f074b","655":"280fe5d614e4b559c637"}[chunkId] + ".js";
};